import { render } from "./Organization.vue.js?vue&type=template&id=0bb96509&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=template&id=0bb96509&scoped=true"
import script from "./Organization.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=script&lang=js"
export * from "./Organization.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=script&lang=js"

import "./Organization.vue.css?vue&type=style&index=0&id=0bb96509&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=style&index=0&id=0bb96509&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb96509"],['__file',"src/Web/scripts/pages/settings/Organization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bb96509"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bb96509', __exports__)) {
    api.reload('0bb96509', __exports__)
  }
  
  module.hot.accept("./Organization.vue.js?vue&type=template&id=0bb96509&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=template&id=0bb96509&scoped=true", () => {
    api.rerender('0bb96509', render)
  })

}


export default __exports__